module.exports = __webpack_public_path__ + "static/media/tools-area-zoom.d08a1529.svg";